import React from "react";
import { useRouteMatch } from "react-router-dom";

import CardCreateLine from "components/Cards/CardCreateLineTest";

export default function RegisterLine() {

  const selected_enterprise = useRouteMatch().params.id_enterprise;
  return (
    <>
      <div className="flex flex-wrap">
        <div className="w-full lg:w-12/12 px-4">
          <CardCreateLine id_enterprise={selected_enterprise}/>
        </div>
      </div>
    </>
  );
}
